export default __webpack_public_path__ + "static/media/adalogo.91660e43.png";